import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsIncidentReportService} from '../../services/settings-incident-report.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'settings-incident-report',
  templateUrl: './settings-incident-report.component.html'
})
export class SettingsIncidentReportComponent implements OnInit, OnDestroy {

    constructor(
        public settingsIncidentReportService: SettingsIncidentReportService,
        public urlService: UrlService,
    ) { }

    ngOnInit(): void {
        this.settingsIncidentReportService.getBuildings();
        this.settingsIncidentReportService.getUserRoles();

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.settingsIncidentReportService.showDetailedView = false;
                        this.settingsIncidentReportService.selectedItemData = null;
                    }
                ),
                flatMap(() => this.settingsIncidentReportService.getDataByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.urlService.setQueryParams('allIncidentReportsSettings');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsIncidentReportService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsIncidentReportService.emptyRowService.fillEmptyRow();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report.component.ts